// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"429":"c8b58a67","453":"2b33ee89","572":"0b5ff2e4","826":"8cea6159","844":"554c38fc","892":"85dd158e","912":"4f5c9e49","933":"77a97a55"}[chunkId] + ".chunk.js";
};